/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 React components
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import ProfileInfoCard from "components/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "components/Lists/ProfilesList";
import DefaultProjectCard from "components/Cards/ProjectCards/DefaultProjectCard";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";
import { CorporateAccount} from "../../models/corporateAccountModel";
// Data
import corporateAccountService from "../../services/corporateAccountService";
//import profilesListData from "layouts/profile/data/profilesListData";
import NotificationAlert from "../../controls/NotificationAlert";
import userProfileService from "../../services/userProfileService";
// Images
import homeDecor1 from "assets/images/home-decor-1.jpg";
import homeDecor2 from "assets/images/home-decor-2.jpg";
import homeDecor3 from "assets/images/home-decor-3.jpg";
import homeDecor4 from "assets/images/home-decor-4.jpeg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { useUser } from "context/UserContext";
import EditCorporateAccountModal from "controls/EditCorporateAccountModal";
import exceptionService from "services/exceptionService";
import { useEffect, useState } from "react";
import EditProfileModal from "controls/EditProfileModal";
import {APP_NAME, MESSAGES_ERROR, MESSAGES_VALIDATION} from '../../constants';
import CorporateAdminList from "controls/CorporateAdminsList";
import MDButton from "../../mdComponents/MDButton";
import CorporateAdminDetailsModal from "controls/CorporateAdminDetailsModal";
import { CircularProgress } from "@mui/material";
import LoadingSpinner from "controls/LoadingSpinner";

const Overview = () => {

  const { user, userCorporateAccount, setUserCorporateAccount, setUserInfo } = useUser();
  const [saving, setSaving ] = useState(false);
  const [showEditCorporateAccountModal, setShowEditCorporateAccountModal ] = useState(false);
  const [showEditProfileModal, setShowEditProfileModal ] = useState(false);
  const [savingCorporateAdmins, setSavingCorporateAdmins ] = useState(false);
  const [showItemDetails, setShowItemDetails] = useState(false);
  const [showNewItem, setShowNewItem] = useState(false);
  const [viewingItem, setViewingItem] = useState();

  const [admins, setAdmins] = useState();
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackbar, setSnackbar] = useState({
      color: "success",
      content: "Location Saved Successfully!",
      title: "Save Successful",
      icon: "check",
      dateTime: "just now",
  });
  const openSnackBar = () => setShowSnackBar(true);
  const closeSnackBar = () => setShowSnackBar(false);

  useEffect(()=> {
    loadAdmins();
  },[]);
    const loadAdmins = async() => {      
      try {
          const data = await corporateAccountService.getCorporateAccountAdminByCorporateAccountId(userCorporateAccount?.id);
          if(data){
            setAdmins(data);
          }
        } catch (err) {     
          throw err;
        }
        finally{
         //   setLoadingAdmins(false);
        }
    };



  const confirmEditCorporateAccountModal = (newAccountInfo) => {
    //save edits
    saveCorporateAccountChanges(newAccountInfo);
  };
  const cancelEditCorporateAccountModal = () => {
    setShowEditCorporateAccountModal(false);
  };
  
  const confirmEditProfileModal = (newUser) => {
    //save edits
    saveProfileChanges(newUser);
  };
  const cancelEditProfileModal = () => {
    setShowEditProfileModal(false);
  };
  
    const onAddAdmin = () => {
    //show a modal to add a record
      setShowNewItem(true);
    };

    const onItemSelect = (item) => {
      setViewingItem(item);
      setShowItemDetails(true);
    };

    const onItemDone = () => {
      setShowItemDetails(false);
      loadAdmins();
    };
    const onNewItemDone = () => {
      setShowNewItem(false);
      loadAdmins();
    };

     const deleteAdmin = (adminObject) => {
      //delete the host user record
      setSavingCorporateAdmins(true);
      //call
      doDelete(adminObject.id);
    };

    const doDelete = async(id) => {
      try {
          const result = await corporateAccountService.deleteAccountAdmin(id);
          if(result === true){
            setSnackbar({
                color: "success",
                content: "Admin Deleted",
                title: "Delete Successful!",
                icon: "check",
                dateTime: "just now",
            });
            openSnackBar();

            loadAdmins();
          }
          else{
            setSnackbar({
                color: "error",
                content: MESSAGES_ERROR.ERROR_DELETING_CORPORATE_ACCOUNT_ADMIN,
                title: "Delete Failed",
                icon: "error",
                dateTime: "just now",
            });
            openSnackBar();
          }
          setShowItemDetails(false);
          setShowNewItem(false);
          setSavingCorporateAdmins(false);
        } catch (err) {     
          setSavingCorporateAdmins(false);       
          throw err;
        }
    };
    
    const updateAdmin = (newAdmin) => {
      
      if(!/\S+@\S+\.\S+/.test(newAdmin.email)){
          setSnackbar({
                color: "error",
                content: MESSAGES_VALIDATION.VALIDATION_EMAIL,
                title: "Delete Failed",
                icon: "error",
                dateTime: "just now",
            });
            openSnackBar();

        return;
      }

      setSavingCorporateAdmins(true);
      //save the updated email on the record
      doSave(newAdmin, true);
    };
    const insertAdmin = (newHostUser) => {
      if(!/\S+@\S+\.\S+/.test(newHostUser.email)){
            setSnackbar({
                color: "error",
                content: MESSAGES_VALIDATION.VALIDATION_EMAIL,
                title: "Delete Failed",
                icon: "error",
                dateTime: "just now",
            });
            openSnackBar();
        
        return;
      }

      setSavingCorporateAdmins(true);
      //save
      doSave(newHostUser, false);
    };
    

    const doSave = async(newAdmin, isUpdate) => {
      try {
        let result = false;
          if(isUpdate){
            result = await corporateAccountService.updateAccountAdmin(newAdmin.id, newAdmin.email);
          }
          else{
            const useNewAdmin = {
              email: newAdmin.email,
              corporateAccountId: userCorporateAccount?.id,
            };
            result = await corporateAccountService.insertAccountAdmin(useNewAdmin);
          }
          if(result === true){
            setSnackbar({   
              color: "success",
              content: "Admin Saved Successfully!",
              title: "Save Successful",
              icon: "check",
              dateTime: "just now",
            });
            openSnackBar();
            loadAdmins();
          }
          else{
              setSnackbar({
                    color: 'error',
                    content: MESSAGES_ERROR.ERROR_UPDATING_CORPORATE_ACCOUNT_ADMIN,
                    title: 'Error Saving',
                    icon: 'error',
                    dateTime: 'just now'
                });
                openSnackBar();

          }
          setShowItemDetails(false);
          setShowNewItem(false);
          setSavingCorporateAdmins(false);
        } catch (err) {     
          setSavingCorporateAdmins(false);       
          throw err;
        }
    };


  const showit = () => {
    if(user.isCorporateAccountOwner){
      setShowEditCorporateAccountModal(true);
    }
  };

  const saveProfileChanges = async(newUser) => {
        await userProfileService.updateProfile(newUser, user.id).then((result) =>{
          if(result){
            setUserInfo(newUser.firstName, newUser.lastName, newUser.phone);
            //setPhoneNumberVerified(false);
            //setShowPhoneNumberVerifyModal(false);
            setShowEditProfileModal(false);
            //setEditMode(false);
            setSnackbar({   
              color: "success",
              content: "Profile Saved Successfully!",
              title: "Save Successful",
              icon: "check",
              dateTime: "just now",
            });
            openSnackBar();
          }
          else
                setSnackbar({
                    color: 'error',
                    content: MESSAGES_ERROR.ERROR_PROFILE_CHANGES,
                    title: 'Error Saving',
                    icon: 'error',
                    dateTime: 'just now'
                });
                openSnackBar();
          });       
        }
       

      const saveCorporateAccountChanges = async(newAccountInfo) => {
        try{
            setSaving(true);
            const result = await corporateAccountService.updateCorporateAccount(newAccountInfo, userCorporateAccount?.id);
            if(result){
                //set
                setSaving(false);
                //update the user in the user context state
                setUserCorporateAccount(newAccountInfo);

                setShowEditCorporateAccountModal(false);
                  setSnackbar({   
                  color: "success",
                  content: "Account Information Updated Successfully!",
                  title: "Save Successful",
                  icon: "check",
                  dateTime: "just now",
              });
              openSnackBar();
            }
            else{
                setSnackbar({
                    color: 'error',
                    content: 'Unable to Save Account Information. Please try again.',
                    title: 'Error Saving',
                    icon: 'error',
                    dateTime: 'just now'
                });
                openSnackBar();
            }

        }catch(error){
            exceptionService.logError(error, "AddCorporateAccount.doSave", user?.id);
                setSnackbar({
                    color: 'error',
                    content: 'There was a problem saving. ' + error.message,
                    title: 'Error Saving',
                    icon: 'error',
                    dateTime: 'just now'
                });
                openSnackBar();
        }         
        finally{
            setSaving(false);
        }  
    };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Header>
        <MDBox>
          {showNewItem && <CorporateAdminDetailsModal selectedItem={viewingItem} onDone={onNewItemDone} visible={showNewItem} onSaveChanges={insertAdmin} editMode={false} />}
          {showItemDetails && <CorporateAdminDetailsModal selectedItem={viewingItem} onDone={onItemDone} visible={showItemDetails} onSaveChanges={updateAdmin} editMode={true} />}
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4}>
              {/* <PlatformSettings /> */}
              <ProfileInfoCard
                title="corporate account"
                description="Corporate account contact information."
                info={{
                  businessName: userCorporateAccount.businessName,
                  contact: `${userCorporateAccount.contactFirstName} ${userCorporateAccount.contactLastName}`,
                  phone: userCorporateAccount.contactPhone,
                  email: userCorporateAccount.contactEmail,
                  address: userCorporateAccount.address,
                  address99: `${userCorporateAccount.city}, ${userCorporateAccount.state} ${userCorporateAccount.zip}`,
                }}                
                action={{ route: "", tooltip: "Edit Corporate Account", onShowEdit:showit }}
                shadow={false}
                hideEditButton={!user.isCorporateAccountOwner}
              />
              {showEditCorporateAccountModal && 
              <EditCorporateAccountModal visible={showEditCorporateAccountModal} account={userCorporateAccount} 
                    onSave={confirmEditCorporateAccountModal } onCancel={cancelEditCorporateAccountModal} />
              }
              
            </Grid>
            <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="profile information"
                description={user.isCorporateAccountOwner ? `Your account is the main corporate account for ${userCorporateAccount.businessName}`: `Your account is assigned as an admin for ${userCorporateAccount.businessName}` }
                info={{
                  name: `${user.firstName} ${user.lastName}`,
                  phone: user.phone,
                  email: user.email,
                  //location: user.created,
                }}                
                action={{ route: "", tooltip: "Edit Profile", onShowEdit: () => setShowEditProfileModal(user.isCorporateAccountOwner) }}
                shadow={false}
                hideEditButton={!user.isCorporateAccountOwner}
              />
              {showEditProfileModal && 
              <EditProfileModal visible={showEditProfileModal} 
                    onSave={confirmEditProfileModal } onCancel={cancelEditProfileModal} />
              }
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
            <Grid item xs={12} xl={4}>
              {admins && 
                <CorporateAdminList
                    title="Corporate Admins" 
                    description={`${APP_NAME} app users associated with these email addresses have access to all locations and some corporate settings. Please note ${APP_NAME} does not validate these email adresses, nor any associated ${APP_NAME} accounts.`}
                    noRecordsMessage="No corporate admins have been added."
                    admins={admins} shadow={false}
                    onAddAdmin={()=> setShowNewItem(true)}
                    onRemoveAdmin={deleteAdmin}
                    onEditAdmin={onItemSelect} />
              }
                {savingCorporateAdmins && (
                  <LoadingSpinner size={30} title='Updating Corporate Admin...' />
                )}        
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <MDBox mb={3} />
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
